import {
  GET_DASHBOARD_INFO,
  GET_DASHBOARD_INFO_SUCCESS,
  GET_DASHBOARD_INFO_FAIL,
  GET_DASHBOARD_INFO_FILTER,
  GET_MEDIAN_AVERAGE_INFO,
  GET_MEDIAN_AVERAGE_INFO_SUCCESS,
  GET_MEDIAN_AVERAGE_INFO_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

export const getDashboardInfo = id => ({
  type: GET_DASHBOARD_INFO,
  payload: id,
})
export const getDashboardInfoSuccess = info => ({
  type: GET_DASHBOARD_INFO_SUCCESS,
  payload: info,
})
export const getDashboardInfoFail = error => ({
  type: GET_DASHBOARD_INFO_FAIL,
  payload: error,
})

export const getDashboardInfoFilter = info => ({
  type: GET_DASHBOARD_INFO_FILTER,
  payload: info,
})

export const getMedianAndAverage = id => ({
  type: GET_MEDIAN_AVERAGE_INFO,
  payload: id,
})
export const getMedianAndAverageSuccess = info => ({
  type: GET_MEDIAN_AVERAGE_INFO_SUCCESS,
  payload: info,
})
export const getMedianAndAverageFail = error => ({
  type: GET_MEDIAN_AVERAGE_INFO_FAIL,
  payload: error,
})

export const showLoading = status => ({
  type: SHOW_LOADING,
  payload: status,
})
export const hideLoading = status => ({
  type: HIDE_LOADING,
  payload: status,
})
